import { PayPeriodEnum } from '@umss/shared/utils';

export interface CorporatePayPeriodSettings {
  /**
   * format: int32
   */
  id?: number;

  /**
   * format: uuid
   */
  corporationId?: string;

  payPeriodType?: PayPeriodEnum;

  payPeriodTypeDisplay?: string;

  /**
   * format: date
   */
  startDate?: string;

  /**
   * format: date
   */
  endDate?: string;

  /**
   * format: date
   */
  nextPayDate?: string;

  /**
   * format: int32
   */
  firstPaymentDay?: number;

  /**
   * format: int32
   */
  secondPaymentDay?: number;

  /**
   * format: date
   */
  anchorDate?: string;

  customPayDates?: string[];

  isPendingUpdate?: boolean;
}

export type PayPeriodType = number;

export interface UpdateCorporatePayPeriodDto {
  payPeriodType: PayPeriodEnum;

  /**
   * format: int32
   * minimum: 1
   * maximum: 31
   */
  firstPaymentDay: number;

  /**
   * format: int32
   * minimum: 1
   * maximum: 31
   */
  secondPaymentDay?: number;

  /**
   * format: date
   */
  anchorDate?: string;

  customPayDates?: string[];
}
